import EventScroller from '../../utilities/js/event-scroller';
import { initScrollToAnchor } from '../../utilities/js/scroll-to-anchor';
import ScrollLock from '../../components/scroll-lock/scroll-lock';

class Navigation {
    constructor(element, options) {

        const settings = {
            initAttr: 'data-siteheader',
            hiddenClassname: 'siteheader--hidden',
            visibleClassname: 'siteheader--overlay',
            offset: 0
        };

        this.settings = Object.assign({}, settings, options);

        this.$navigation = element;
        this.$navigationToggle = this.$navigation.querySelector('[data-nav="root_toggle"]');
        this.$searchOverlayToggleCheckbox = this.$navigation.querySelector('[data-nav="search_toggle"]');
        this.$searchOverlayInput = this.$navigation.querySelector('[data-search="input"]');
        this.$$navigationAnchorLink = this.$navigation.querySelectorAll('[data-nav="anchor"]');
        this.$siteheader = document.querySelector('[data-siteheader="root"]');
        this.$sitemain = document.querySelector('[data-main="root"]');
        this.$body = document.body;
        this.viewportWidth = window.innerWidth;

        if (this.$siteheader && this.$navigationToggle && this.$sitemain) {
            this.initialize();
        }
    }

    initialize() {
        this.setEvents();
    }

    setEvents () {
        // Handling visibility of navigation on scroll
        const eventScroller = new EventScroller({
            onScroll: (position, direction) => {
                if(position > 100) {
                    if(direction === 'down') {
                        this.$siteheader.classList.add(this.settings.hiddenClassname);
                        this.$siteheader.classList.remove(this.settings.visibleClassname);
                    } else if(direction === 'up') {
                        this.$siteheader.classList.add(this.settings.visibleClassname);
                    }
                } else {
                    this.$siteheader.classList.remove(this.settings.hiddenClassname);
                    this.$siteheader.classList.remove(this.settings.visibleClassname);
                }
            }
        });

        eventScroller.initialize();

        // clean up open states and locks
        window.mediaMatchHandler[1024].addEventListener('change', () => {
            this.closeNav();
        });

        // close navigation on orientationchange
        window.addEventListener('orientationchange', () => {
            this.closeNav();
        });

        // close navigation on outside click
        document.addEventListener('click', (e) => {
            if (!this.$siteheader.contains(e.target)) {
                this.closeNav();
            }
        });

        // close navigation on outside focus
        if (this.$sitemain && this.$navigationToggle) {
            this.$sitemain.addEventListener('focus', (e) => {
                if (!this.$siteheader.contains(e.target)) {
                    this.closeNav();
                }
            });
        }

        if (this.$$navigationAnchorLink.length > 0) {
            this.$$navigationAnchorLink.forEach($anchor => {
                $anchor.addEventListener('click', () => {
                    const targetId = $anchor.getAttribute('href').split('#')[1];

                    if (targetId) {
                        initScrollToAnchor(targetId);

                        window.setTimeout(() => {
                            this.closeNav();
                            clearTimeout(this);
                        }, 300);
                    }
                });
            });
        }

        // close navigation on the ESC key
        document.addEventListener('keydown', (e) => {
            if (e.code === 'Escape' || e.key === 'Esc') {
                if (this.$siteheader.contains(e.target)) {
                    this.closeNav();
                }
            }
        });

        window.addEventListener('checkbox.trigger.click', (e) => {
            const $checkbox = e.detail?.checkbox;

            if ($checkbox) {
                const navLevel = $checkbox.dataset.navLevel;

                if (navLevel === '1') {
                    this.closeNav($checkbox);
                }

                if (navLevel === '2' || navLevel === '3') {
                    this.closeAllSubNavExcept($checkbox, navLevel);
                }
            }
        });

        window.addEventListener('checkbox.trigger.active', (e) => {
            if (this.$searchOverlayToggleCheckbox === e.detail.checkbox) {
                this.checkSearchToggle();
            }

            if (this.$navigationToggle === e.detail.checkbox) {
                if (this.$searchOverlayToggleCheckbox.checked) {
                    window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            referenceId: this.$searchOverlayToggleCheckbox.id,
                            state: false
                        }
                    }));
                }

                if (e.detail.state === true) {
                    ScrollLock.disableScroll();
                    this.closeAllSubNavExcept(e.detail.checkbox);
                } else {
                    ScrollLock.enableScroll();
                }
            }

            if (window.mediaMatchHandler[1024].matches && (e.detail.checkbox && e.detail.checkbox.getAttribute('data-nav-level') === '1')) {
                if (e.detail.state === true) {
                    ScrollLock.disableScroll();
                } else {
                    ScrollLock.enableScroll();
                }
            }
        });
    }

    closeNav ($currentElement = null) {
        if (($currentElement === this.$searchOverlayToggleCheckbox || $currentElement === null) && this.$navigationToggle.checked) {
            window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    referenceId: this.$navigationToggle.id,
                    state: false
                }
            }));

            this.cleanUpScrollLock();
        }

        if (($currentElement !== this.$searchOverlayToggleCheckbox || $currentElement === this.$navigationToggle || $currentElement === null) && this.$searchOverlayToggleCheckbox.checked) {
            window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    referenceId: this.$searchOverlayToggleCheckbox.id,
                    state: false
                }
            }));

            this.cleanUpScrollLock();
        }

        if (window.mediaMatchHandler[1024].matches) {
            this.closeAllSubNavExcept($currentElement);
            this.cleanUpScrollLock();
        }

        // cleanup scroll lock on if the screen is > 1024px
        window.mediaMatchHandler[1024].addEventListener('change', () => {
            this.cleanUpScrollLock();
        });
    }

    checkSearchToggle () {
        if (this.$navigationToggle.checked) {
            window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    referenceId: this.$navigationToggle.id,
                    state: false
                }
            }));
        }

        if (this.$searchOverlayToggleCheckbox.checked) {
            ScrollLock.disableScroll();
            this.closeAllSubNavExcept();

            if (this.$searchOverlayInput) {
                setTimeout(() => {
                    this.$searchOverlayInput.focus();
                }, 200);
            }
        } else {
            ScrollLock.enableScroll();
        }
    }

    cleanUpScrollLock () {
        // clean up scroll lock
        if (this.$body.classList.contains('scroll-lock-active')) {
            ScrollLock.disableScroll();
            ScrollLock.enableScroll();
        }
    }

    closeAllSubNavExcept ($currentElement, navLevel = null) {
        const $$openNavElement = this.$siteheader.querySelectorAll('[data-nav="toggle"]:checked');

        if ($$openNavElement.length > 0) {
            $$openNavElement.forEach(($openNavElement) => {
                let close = false;

                if (navLevel !== null) {
                    if (navLevel === $openNavElement.dataset.navLevel && $openNavElement !== $currentElement) {
                        close = true;
                    }
                } else {
                    if ($openNavElement !== $currentElement) {
                        close = true;
                    }
                }

                if (close === true) {
                    window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            referenceId: $openNavElement.id,
                            state: false
                        }
                    }));
                }
            });
        }
    }
}

export { Navigation };

window.addEventListener('content.loaded', (e) => {
    const context = e.detail.$context;

    if (context) {
        const $navigation = context.querySelector('[data-nav="root"]');

        if ($navigation) {
            const navigationAPI = new Navigation($navigation);
            $navigation.navAPI = navigationAPI;
        }
    }
});
